/* STARKFELD newsletter transport. Configuration is generated from binding.json.
 * A 202 acknowledgment is not proof of consent, list membership or mail delivery.
 * Sensitive request state exists only in the open page's memory. */
(function (root) {
  'use strict';
  if (root.SfNewsletterHub) return;
  var MESSAGES = {
    de: {
      unavailable: 'Die Newsletter-Anmeldung ist zurzeit nicht verfügbar. Bitte versuche es später erneut.',
      preview: 'Vorschau: Die Anmeldung ist hier deaktiviert.',
      invalid_email: 'Bitte gib eine gültige E-Mail-Adresse ein.',
      retry_locked: 'Bitte wiederhole die Anfrage mit derselben E-Mail-Adresse. Für eine andere Adresse lade diese Seite neu.',
      binding_changed: 'Die Anmeldung wurde inzwischen geändert. Bitte lade diese Seite neu.',
      challenge_expired: 'Das Zeitfenster für diese Anmeldung ist abgelaufen. Die Anfrage wurde angehalten.',
      retry_expired: 'Diese Anfrage ist zu alt, um sie sicher zu wiederholen. Bitte prüfe dein Postfach oder wende dich an den STARKFELD-Support.',
      clock_changed: 'Die Zeitprüfung ist nicht mehr zuverlässig. Die Anfrage wurde angehalten. Bitte prüfe dein Postfach oder wende dich an den STARKFELD-Support.',
      network: 'Die Anfrage konnte nicht sicher bestätigt werden. Bitte versuche es erneut; deine bisherige Anfrage wird wiederverwendet.',
      protocol: 'Die Anmeldung konnte nicht sicher bestätigt werden. Bitte versuche es später erneut.',
      accepted: 'Falls deine Adresse noch bestätigt werden muss, erhältst du eine E-Mail mit dem Bestätigungslink. Dein persönlicher Willkommensbonus folgt nach der Bestätigung.'
    },
    en: {
      unavailable: 'Newsletter signup is currently unavailable. Please try again later.',
      preview: 'Preview: Signup is disabled here.',
      invalid_email: 'Please enter a valid email address.',
      retry_locked: 'Please retry with the same email address. Reload this page to use a different address.',
      binding_changed: 'Signup settings have changed. Please reload this page.',
      challenge_expired: 'The time window for this signup has expired. The request has been stopped.',
      retry_expired: 'This request is too old to retry safely. Please check your inbox or contact STARKFELD support.',
      clock_changed: 'The time check is no longer reliable. The request has been stopped. Please check your inbox or contact STARKFELD support.',
      network: 'Your request could not be confirmed. Please try again; your original request will be reused.',
      protocol: 'Signup could not be confirmed. Please try again later.',
      accepted: 'If your address still needs confirmation, you will receive an email with a confirmation link. Your personal welcome bonus follows confirmation.'
    }
  };
  function fault(code) { var error = new Error(code); error.code = code; return error; }
  function localeOf(value) { return /^en(?:-|$)/i.test(value || '') ? 'en' : 'de'; }
  function message(code, locale) { return MESSAGES[localeOf(locale)][code] || MESSAGES[localeOf(locale)].protocol; }
  function validateBinding(raw) {
    if (!raw || typeof raw !== 'object') throw fault('unavailable');
    var origin;
    try { origin = new URL(raw.origin); } catch (_) { throw fault('unavailable'); }
    if (origin.protocol !== 'https:' || origin.origin !== raw.origin || origin.username || origin.password ||
        !/^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i.test(origin.hostname)) throw fault('unavailable');
    if (typeof raw.formId !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(raw.formId)) throw fault('unavailable');
    if (typeof raw.consentTextVersion !== 'string' || !/^[A-Za-z0-9._:-]{1,128}$/.test(raw.consentTextVersion)) throw fault('unavailable');
    if (!Number.isInteger(raw.nonceMaxAgeSeconds) || raw.nonceMaxAgeSeconds < 60 || raw.nonceMaxAgeSeconds > 604800) throw fault('unavailable');
    if (typeof raw.localeField !== 'boolean' || typeof raw.honeypotField !== 'string' ||
        (raw.honeypotField && (!/^[A-Za-z_][A-Za-z0-9_]{0,63}$/.test(raw.honeypotField) ||
        /^(?:email|nonce|consentTextVersion|locale|brand|list)$/i.test(raw.honeypotField)))) throw fault('unavailable');
    var endpoint = origin.origin + '/m/forms/starkfeld/' + raw.formId;
    if (raw.hostedFormUrl !== '' && raw.hostedFormUrl !== endpoint) throw fault('unavailable');
    return Object.freeze({ origin: origin.origin, formId: raw.formId, consentTextVersion: raw.consentTextVersion,
      hostedFormUrl: raw.hostedFormUrl, localeField: raw.localeField, honeypotField: raw.honeypotField,
      nonceMaxAgeSeconds: raw.nonceMaxAgeSeconds, endpoint: endpoint });
  }
  function normalizeEmail(value) {
    if (typeof value !== 'string') throw fault('invalid_email');
    var email = value.trim();
    if (email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) throw fault('invalid_email');
    return email.slice(0, email.lastIndexOf('@') + 1) + email.slice(email.lastIndexOf('@') + 1).toLowerCase();
  }
  function createSession(readBinding, options) {
    options = options || {};
    var binding = validateBinding(readBinding());
    var fingerprint = JSON.stringify(binding);
    var fetchRequest = options.fetch || root.fetch.bind(root);
    var now = options.now || function () { return root.performance.now(); };
    var wallNow = options.wallNow || function () { return root.Date.now(); };
    var wait = options.wait || function (ms) { return new Promise(function (resolve) { root.setTimeout(resolve, ms); }); };
    var requestTimeoutMs = options.timeoutMs || 15000;
    var expirySafetyMs = 2000;
    var lastTime = null, clockBlocked = false;
    var challenge = null, preparing = null, inFlight = null, inFlightInput = null, attempted = null, accepted = false;
    function timePoint() {
      var point = { monotonic: now(), wall: wallNow() };
      if (clockBlocked || !Number.isFinite(point.monotonic) || !Number.isFinite(point.wall) ||
          (lastTime && (point.monotonic < lastTime.monotonic || point.wall < lastTime.wall))) {
        clockBlocked = true;
        throw fault('clock_changed');
      }
      lastTime = point;
      return point;
    }
    function assertLifetime(reserveMs) {
      var point = timePoint();
      var age = Math.max(point.monotonic - challenge.startedAt.monotonic, point.wall - challenge.startedAt.wall);
      if (age + expirySafetyMs + reserveMs >= binding.nonceMaxAgeSeconds * 1000) {
        throw fault(attempted ? 'retry_expired' : 'challenge_expired');
      }
    }
    function assertBinding() {
      var current;
      try { current = validateBinding(readBinding()); } catch (_) { throw fault('binding_changed'); }
      if (JSON.stringify(current) !== fingerprint) throw fault('binding_changed');
    }
    async function request(path, init) {
      var controller = new root.AbortController();
      var timeout = root.setTimeout(function () { controller.abort(); }, requestTimeoutMs);
      try {
        var response = await fetchRequest(path, Object.assign({ credentials: 'omit', mode: 'cors', cache: 'no-store',
          redirect: 'error', referrerPolicy: 'no-referrer', signal: controller.signal }, init));
        if (response.status !== 200 && response.status !== 202) return { status: response.status };
        var body;
        try { body = await response.json(); } catch (_) { throw fault('protocol'); }
        return { status: response.status, body: body };
      } catch (error) { throw fault(error.code === 'protocol' ? 'protocol' : 'network'); }
      finally { root.clearTimeout(timeout); }
    }
    function prepare() {
      if (challenge) return Promise.resolve();
      if (preparing) return preparing;
      preparing = (async function () {
        assertBinding();
        var startedAt = timePoint();
        var response = await request(binding.endpoint + '/challenge', { method: 'GET', headers: { Accept: 'application/json' } });
        if (response.status !== 200) throw fault('network');
        var body = response.body;
        if (!body || typeof body.nonce !== 'string' || !/^f1\.[A-Za-z0-9_-]{1,256}\.[A-Za-z0-9_-]{43}$/.test(body.nonce) ||
            !Number.isInteger(body.minSubmitSeconds) || body.minSubmitSeconds < 0 || body.minSubmitSeconds > 300) throw fault('protocol');
        assertBinding();
        challenge = { nonce: body.nonce, startedAt: startedAt, readyAt: timePoint().monotonic + body.minSubmitSeconds * 1000 + 250 };
        assertLifetime(body.minSubmitSeconds * 1000 + 250 + requestTimeoutMs);
      })().finally(function () { preparing = null; });
      return preparing;
    }
    function submit(emailValue, locale, honeypot) {
      var email, normalizedLocale = localeOf(locale);
      try {
        assertBinding();
        email = normalizeEmail(emailValue);
        if (attempted && (attempted.email !== email || attempted.locale !== normalizedLocale || attempted.honeypot !== (honeypot || ''))) throw fault('retry_locked');
        if (inFlightInput && (inFlightInput.email !== email || inFlightInput.locale !== normalizedLocale || inFlightInput.honeypot !== (honeypot || ''))) throw fault('retry_locked');
      } catch (error) { return Promise.reject(error); }
      if (accepted) return Promise.resolve({ accepted: true });
      if (inFlight) return inFlight;
      inFlightInput = { email: email, locale: normalizedLocale, honeypot: honeypot || '' };
      inFlight = (async function () {
        if (!attempted) {
          // No POST was attempted: discard any preloaded challenge before sending.
          if (preparing) await preparing;
          challenge = null;
        }
        await prepare();
        assertLifetime(requestTimeoutMs);
        var remaining = challenge.readyAt - now();
        while (remaining > 0) {
          await wait(Math.ceil(remaining));
          var nextRemaining = challenge.readyAt - now();
          if (nextRemaining >= remaining) throw fault('protocol');
          remaining = nextRemaining;
        }
        assertBinding();
        assertLifetime(requestTimeoutMs);
        var payload = { nonce: challenge.nonce, email: email, consentTextVersion: binding.consentTextVersion };
        if (binding.localeField) payload.locale = normalizedLocale;
        if (binding.honeypotField) payload[binding.honeypotField] = honeypot || '';
        attempted = { email: email, locale: normalizedLocale, honeypot: honeypot || '' };
        var response = await request(binding.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
        assertBinding();
        assertLifetime(0);
        if (response.status !== 202) throw fault('network');
        var body = response.body;
        if (!body || body.ok !== true) throw fault('protocol');
        assertBinding();
        accepted = true;
        return { accepted: true };
      })().finally(function () { inFlight = null; inFlightInput = null; });
      return inFlight;
    }
    return Object.freeze({ prepare: prepare, submit: submit });
  }
  var shared = null;
  function mountedSession(readBinding) {
    var fingerprint = JSON.stringify(validateBinding(readBinding()));
    if (shared) {
      if (shared.fingerprint !== fingerprint) throw fault('binding_changed');
      shared.readers.push(readBinding);
      return shared.session;
    }
    shared = { fingerprint: fingerprint, readers: [readBinding], session: null };
    shared.session = createSession(function () {
      var current;
      shared.readers.forEach(function (read) {
        current = read();
        if (JSON.stringify(validateBinding(current)) !== shared.fingerprint) throw fault('binding_changed');
      });
      return current;
    });
    return shared.session;
  }
  function mount(form, handlers) {
    if (!form || form._sfHubMounted) return;
    form._sfHubMounted = true;
    handlers = handlers || {};
    var container = form.closest('[data-sf-hub-root]');
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var errorElement = handlers.errorElement || container.querySelector('[data-sf-hub-error]');
    var resultElement = container.querySelector('[data-sf-hub-result]');
    var locale = localeOf(root.document.documentElement.lang);
    var busy = false, complete = false, blocked = false, session;
    function showError(code) {
      if (errorElement) { errorElement.textContent = message(code, locale); errorElement.hidden = false; errorElement.classList.add('is-visible'); }
    }
    function readBinding() {
      var node = container.querySelector('script[data-sf-hub-binding]');
      try { return JSON.parse(node.textContent); } catch (_) { throw fault('unavailable'); }
    }
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (!session || busy || complete) return;
      busy = true; button.disabled = true; input.disabled = true;
      if (errorElement) { errorElement.textContent = ''; errorElement.classList.remove('is-visible'); }
      if (handlers.onBusy) handlers.onBusy(true);
      try {
        var honeypot = form.querySelector('[data-sf-hub-honeypot]');
        await session.submit(input.value, locale, honeypot ? honeypot.value : '');
        complete = true;
        root.document.dispatchEvent(new CustomEvent('sf:newsletter-request-accepted'));
        if (resultElement) { resultElement.hidden = false; resultElement.textContent = message('accepted', locale); }
        if (handlers.onAccepted) handlers.onAccepted(input.value);
      } catch (error) { blocked = ['binding_changed', 'challenge_expired', 'retry_expired', 'clock_changed'].includes(error.code); showError(error.code); }
      finally {
        busy = false; button.disabled = complete || blocked; input.disabled = complete || blocked;
        if (handlers.onBusy) handlers.onBusy(false);
      }
    });
    try {
      if (form.dataset.sfHubPreview === 'true') throw fault('preview');
      var binding = validateBinding(readBinding());
      session = mountedSession(readBinding);
      if (binding.honeypotField) {
        var trap = root.document.createElement('input');
        trap.type = 'text'; trap.name = binding.honeypotField; trap.autocomplete = 'off'; trap.tabIndex = -1;
        trap.dataset.sfHubHoneypot = ''; trap.setAttribute('aria-hidden', 'true');
        trap.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden';
        form.appendChild(trap);
      }
      input.disabled = false; button.disabled = false;
      if (errorElement) { errorElement.textContent = ''; errorElement.hidden = true; errorElement.classList.remove('is-visible'); }
    } catch (error) {
      input.disabled = true; button.disabled = true; showError(error.code);
    }
  }
  root.SfNewsletterHub = Object.freeze({ validateBinding: validateBinding, createSession: createSession, mount: mount, message: message });
  if (root.document) {
    function init(scope) { scope.querySelectorAll('form[data-sf-hub-native]').forEach(function (form) { mount(form); }); }
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', function () { init(root.document); });
    else init(root.document);
    root.document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    root.document.dispatchEvent(new root.CustomEvent('sf:newsletter-hub-ready'));
  }
})(typeof window === 'undefined' ? globalThis : window);
